import { GroupedSpecialization, LearningTreeSpecialization } from '../models/skill-learning.model';

const NO_REQUIRED_LEVEL = 0;
const DEPARTMENT_SCOPE = 'DEPARTMENT';
const SUBDEPARTMENT_SCOPE = 'SUBDEPARTMENT';
const GROUP_PRIORITY = { department: 0, subdepartment: 1, required: 2, other: 3 };

export function isRequiredLearning(specialization: LearningTreeSpecialization): boolean {
  return !!specialization && specialization.effectiveProbationRequiredLevel > NO_REQUIRED_LEVEL;
}

export function hasRequiredLearning(group: GroupedSpecialization): boolean {
  return group.specializations.some(isRequiredLearning);
}

export function prioritizeLearningGroups(groups: GroupedSpecialization[]): GroupedSpecialization[] {
  return groups.map((group, index) => ({ group, index, priority: groupPriority(group) }))
    .sort((left, right) => left.priority - right.priority || left.index - right.index)
    .map(item => Object.assign({}, item.group, {
      specializations: item.group.specializations.map((specialization, index) => ({ specialization, index }))
        .sort((left, right) => Number(isRequiredLearning(right.specialization))
          - Number(isRequiredLearning(left.specialization)) || left.index - right.index)
        .map(entry => entry.specialization),
    }));
}

function groupPriority(group: GroupedSpecialization): number {
  if (group.departmentScope === DEPARTMENT_SCOPE) {
    return GROUP_PRIORITY.department;
  }
  if (group.departmentScope === SUBDEPARTMENT_SCOPE) {
    return GROUP_PRIORITY.subdepartment;
  }
  return hasRequiredLearning(group) ? GROUP_PRIORITY.required : GROUP_PRIORITY.other;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/services/learning-tree-order.ts